<!--Loading is added to while adding basket into order template-->
@if (loading$ | async) {
<ish-loading [fullPage]="true" />
}
<button type="button" [ngClass]="cssClass" (click)="openModal(modal)" data-testing-id="addBasketToOrderTemplateButton">
  {{ 'order_template.create.heading' | translate }}
</button>

<ish-order-template-preferences-dialog
  #modal
  modalTitle="account.order_template.new_from_basket.heading"
  (submitOrderTemplate)="createOrderTemplate($event)"
/>
